/**
 * API client for punctuation restoration
 */

const API_BASE = '/api/chatrooms';

export async function restorePunctuation(text) {
  if (!text || !text.trim()) {
    return text;
  }

  try {
    const response = await fetch(`${API_BASE}/punctuate/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
      },
      credentials: 'include',
      body: JSON.stringify({ text }),
    });

    if (!response.ok) {
      console.error('Punctuation API error:', response.status);
      // Return original text if API fails
      return text;
    }

    const data = await response.json();
    return data.text;
  } catch (error) {
    console.error('Error calling punctuation API:', error);
    // Return original text if API fails
    return text;
  }
}

function getCSRFToken() {
  const name = 'csrftoken';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(name + '=')) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return '';
}
